import mixitup from 'mixitup';
import mixitupPagination from './vendor/mixitup-pagination.min';

var PostFiltering = function PostFiltering() {
  mixitup.use(mixitupPagination);
  var updateLoadmore = null;
  var loadmore = document.querySelector('.post-loadmore');
  var loadmoreInitial = loadmore && loadmore.dataset.loadmoreInitial ? parseInt(loadmore.dataset.loadmoreInitial) : 18;
  var loadmoreIncrement = loadmore && loadmore.dataset.loadmoreIncrement ? parseInt(loadmore.dataset.loadmoreIncrement) : 18;
  var mixer = mixitup('.post-filtering', {
    pagination: {
      limit: loadmoreInitial,
      hidePageListIfSinglePage: true
    },
    animation: {
      duration: 250,
      nudge: true,
      easing: 'ease-out',
      reverseOut: false,
      effects: 'fade'
    },
    callbacks: {
      onMixEnd: function onMixEnd() {
        // window.dispatchEvent(new Event('resize'));
        $(window).trigger('resize');
        return loadmore ? updateLoadmore(loadmore) : null;
      }
    }
  });
  if (mixer.getState().totalTargets <= loadmoreInitial && loadmore) loadmore.style.display = 'none';
  var filters = document.querySelectorAll('.Team-filter select');

  updateLoadmore = function updateLoadmore(ownLoadmore) {
    var limit = mixer.getState().activePagination.limit;

    var _mixer$getState = mixer.getState(),
        totalMatching = _mixer$getState.totalMatching;

    if (limit >= totalMatching) {
      ownLoadmore.classList.add('is-disabled');
      ownLoadmore.disabled = true;
    } else if (ownLoadmore.disabled) {
      ownLoadmore.classList.remove('is-disabled');
      ownLoadmore.disabled = false;
    }
  };

  if (loadmore) {
    loadmore.addEventListener('click', function () {
      console.log(mixer.getState().activePagination.limit + loadmoreIncrement);
      mixer.paginate({
        limit: mixer.getState().activePagination.limit + loadmoreIncrement
      });
      return updateLoadmore(loadmore);
    });
    updateLoadmore(loadmore);
  }

  var filterReset = document.querySelector('.js-filtering-reset');

  if (filterReset) {
    filterReset.addEventListener('click', function () {
      mixer.filter('all');
    });
  }

  Array.from(filters).forEach(function (item) {
    return item.addEventListener('change', function () {
      var filterValues = Array.from(filters).map(function (cur) {
        return cur.options[cur.selectedIndex].value;
      }).join('');
      filterValues = filterValues || 'all';
      return mixer.filter(filterValues);
    });
  }); // -------------------------------------
  // Dropdown({
  //     selector: '.select-filter'
  // });
  // -------------------------------------
  // -------------------------------------

  var getParameterByName = function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[]]/g, '$&');
    var regex = new RegExp("[?&]".concat(name, "(=([^&#]*)|&|#|$)"));
    var results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  };

  var industry = getParameterByName('sector');

  if (industry) {
    var industryClass = ".".concat(industry);
    var option = document.querySelector(".CustomDropdown-list li[data-value=\"".concat(industryClass, "\"]")); // This is really bad
    // :(

    option.click();
    document.body.click(); // mixer.filter(industryClass);
  } // -------------------------------------

};

export default PostFiltering;